import { FallbackProps, ErrorBoundary } from 'react-error-boundary';
import { useQueryErrorResetBoundary } from 'react-query';
import { ErrorPage } from '../../main/components/CustomErrorPages/ErrorPage';

export function GeneralErrorFallback(props: FallbackProps) {
  return <ErrorPage resetErrorBoundary={props.resetErrorBoundary} />;
}

export const withErrorBoundary = (
  Component: React.ComponentType<any>, 
  errorPage = GeneralErrorFallback
) => {
  return (props: any) => {
    const { reset } = useQueryErrorResetBoundary();

    return (
      <ErrorBoundary FallbackComponent={errorPage} onReset={reset}>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
};
